import { StatusBar } from "expo-status-bar";
import { StyleSheet } from "react-native";

import { isIOS } from "@stepapp/core";
import { Block, Typography } from "@stepapp/ui";

export default function ModalScreen() {
  return (
    <Block flex={1} alignCenter justifyCenter>
      <Typography style={styles.title}>Modal</Typography>
      <Block width="80" marginVertical={3.75} />

      <StatusBar style={isIOS ? "light" : "auto"} />
    </Block>
  );
}

const styles = StyleSheet.create({
  title: { fontSize: 20, fontWeight: "bold" },
});
